import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ClientNotSelectedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.client.client-not-selected');
    }
}
